import { render, staticRenderFns } from "./PriceAndDimencion.vue?vue&type=template&id=07431352&scoped=true&"
import script from "./PriceAndDimencion.vue?vue&type=script&lang=js&"
export * from "./PriceAndDimencion.vue?vue&type=script&lang=js&"
import style0 from "./PriceAndDimencion.vue?vue&type=style&index=0&id=07431352&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07431352",
  null
  
)

export default component.exports